module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-2-478e2505f126d5681eb3120219d98685.png";